import React from 'react';
const css = `
    html {
        width: 255mm;
        padding: 0 20mm;
    }

    body {
        font-family: monospace, Lucida Console, Lucida Sans Typewriter, monaco, Bitstream Vera Sans Mono, Menlo-Regular;
        font-size: 32pt;
    }

    table {
        width: 100%;
        border-width: 0;
        border-collapse: collapse;
        table-layout: fixed;
    }
    table.add-padding th,
    table.add-padding td {
        padding: 0.25cm 0cm;
    }

    table th, table td{
        vertical-align: top;
    }

    table.dates th {
        width: 50%
    }

    table td{
        word-wrap: break-word;
    }

    .logo-image-container {
        zoom: 3;
        margin: 0 auto;
        height: 1.55cm;
        margin-bottom: 0.25cm;
    }
    .logo-image-container.zoom-2 {
        zoom: 2;
    }

    .logo-image-div {
        text-align: center;
    }
    .logo-image-div img {
        margin: 0 auto;
    }

    .text-center {
        text-align: center;
    }

    .nw {
        white-space: nowrap;
    }

    .text-left {
        text-align: left;
    }

    table.text-left th, table.text-left td{
        padding-right: 7px;
    }

    .text-right {
        text-align: right;
    }

    .blank_row
    {
        height: 50px;
    }

    .separator {
        border-top: 1px dashed #000;
        margin: 0.5cm 0;
    }

    .cash-summary-heading {
        font-weight: bold;
        margin-bottom: 10px;
    }

    .cash-summary-title {
        text-align: center;
        font-weight: bold;
    }
`;
function CashCollectionReport(props) {
    let today = new Date();
    let date = today.toLocaleDateString('en-US');
    let time = today.toLocaleTimeString('en-US');

    const generateTableRows = (data) => {
        return data.denominations.map((item) => (
            <tr key={item.denomination}>
                <td className='text-left'>{`${data.currencySign}${item.denomination}`}</td>
                <td className='text-right'>{`${item.count} / ${data.currencySign
                    }${item.amount.toLocaleString('en-US')}`}</td>
            </tr>
        ));
    };
    const logo =
        props.receiptAttributes && props.receiptAttributes.isPrintLogoKiosk === true &&
            `data:image/png;base64,${props.receiptAttributes.logo}`;
    return (
        <html>
            <head>
                <style>{css}</style>
            </head>
            <body>
                <div>
                    <div className='logo-image-container zoom-2 logo-image-div'>
                        {logo && <img src={logo} alt='Store logo' />}
                    </div>
                    <table className='text-center'>
                        <tbody>
                            <tr className='blank_row'>
                                <td></td>
                            </tr>
                            <tr>
                                <td>
                                    <span>BATCH CLOSED</span>
                                </td>
                            </tr>
                            <tr className='blank_row'>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <div className='separator'></div>
                    <table className='text-left dates add-padding'>
                        <tbody>
                            <tr>
                                <td className='text-left'>Closed Batch #:</td>
                                <td className='text-right'>
                                    {props.closedBatch}
                                </td>
                            </tr>
                            <tr>
                                <td className='text-left'>Date:</td>
                                <td className='text-right'>{date}</td>
                            </tr>
                            <tr>
                                <td className='text-left'>Time:</td>
                                <td className='text-right'>{time}</td>
                            </tr>
                            <tr>
                                <td className='text-left'>Closed by:</td>
                                <td className='text-right'>{props.closedBy}</td>
                            </tr>
                            <tr>
                                <td className='text-left'>Kiosk ID:</td>
                                <td className='text-right'>{props.kioskId}</td>
                            </tr>
                            <tr className='blank_row'>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className='add-padding'>
                        <tbody>
                            <tr>
                                <td colSpan='2' className='cash-summary-title'>
                                    ------ CASH SUMMARY ------
                                </td>
                            </tr>
                            <tr className='blank_row'>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className='cash-summary-heading'>
                                <td className='text-left'>DENOMINATION</td>
                                <td className='text-right'>COUNT / VALUE</td>
                            </tr>
                            <tr className='separator'>
                                <td></td>
                            </tr>
                            {generateTableRows(props.cashMetrics)}
                        </tbody>
                    </table>
                    <div className='separator'></div>
                    <table className='add-padding'>
                        <tbody>
                            <tr className='cash-summary-heading'>
                                <td className='text-left'>TOTAL COUNT</td>
                                <td className='text-right'>
                                    {props.cashMetrics.totalCount}
                                </td>
                            </tr>
                            <tr className='cash-summary-heading'>
                                <td className='text-left'>TOTAL VALUE</td>
                                <td className='text-right'>
                                    {`${props.cashMetrics.currencySign
                                        }${props.cashMetrics.totalAmount.toLocaleString(
                                            'en-US'
                                        )}`}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className='separator'></div>
                    <table className='add-padding'>
                        <tbody>
                            <tr>
                                <td className='text-left'>New Batch #:</td>
                                <td className='text-right'>{props.newBatch}</td>
                            </tr>
                            <tr className='blank_row'>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <div className='text-center nw'>
                        Please keep this receipt for your records
                    </div>
                </div>
            </body>
        </html>
    );
}

export default CashCollectionReport;
